import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";

import { routes } from "../constants/routes"

/**
 *
 * Prywatny routing aplikacji - wymaga autoryzacji
 * 
 * Opiera sie na fladze authenticated(token w localStorage), w tym momencie jeszcze nie mamy dostepu do pełnego użytkownika - authenticatedUser
 *
 * Jesli osoba nie jest zautentyfikowana - przekierujemy na logowanie
 * 
 * Jesli osoba jest zauntentyfikowana - idziemy dalej
 * 
 */
const PrivateRoute = ({ component: Component, content: Content, layout: Layout, authenticated, intl, ...rest }) => {

  /**
   * Globalna metoda tłumacząca
   * 
   * @param {String} key klucz to tłumaczeń 
   * @param {Object} params obiekt z parametrami do tłumaczenia
   */
  const formatMessage = (key, params) => {
    return intl.formatMessage({ id: key }, params);
  };

  return (
    <Route {...rest} render={(props) =>
      authenticated ? (
        <Layout formatMessage={formatMessage} {...props} {...rest} content={Content} >
          <Component formatMessage={formatMessage} {...props} {...rest} />
        </Layout>
      ) : (
          <Redirect to={{ pathname: routes.LOGIN, state: { from: props.location } }}
          />
        )
    }
    />
  );

};

PrivateRoute.propTypes = {
  authenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  authenticated: state.authReducer.authenticated,
});

const withConnect = connect(
  mapStateToProps
);

export default compose(
  withConnect,
  injectIntl
)(PrivateRoute);